export const ROBOTS_CONSTANTS = {
  PJE_SUFFIX: '-PJE',
}

export default ROBOTS_CONSTANTS
